<template lang="pug">
  v-row(justify="center")
    v-col(lg="6" md="8" cols="12")
      h1.mb-3 {{ $route.params.groupId ? 'Редактировать' : 'Создать'}} группу
      validation-observer(ref="obs" v-slot="{ invalid, passes, pristine, validate, validated }")
        //- server-data(
        //-   :method="$api.teachers.index"
        //-   v-slot="{ serverData }"
        //-   :query="query"
        //- )
        v-form
          validation-provider(
            rules="required"
            name="Краткое наименование"
            vid="short_name"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="fromData.shortName"
              name="short_name"
              label="Краткое наименование"
              :error-messages="errors"
              filled
              rounded
            )
          validation-provider(
            rules="required"
            name="Полное наименование"
            vid="full_name"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="fromData.fullName"
              name="full_name"
              label="Полное наименование"
              :error-messages="errors"
              filled
              rounded
            )
          server-data(
            v-if="!$route.params.groupId"
            ref="serverData"
            v-bind="serverDataAttrs"
            :method="$api.teachers.index"
            v-slot="{ serverData, selectProps, loadMoreItems, search }"
            searchFieldName="search[name]"
          )
            v-autocomplete-more(
              v-model="fromData.teachersSelected"
              v-bind="selectProps"
              item-text="full_name"
              item-value="id"
              color="secondary"
              multiple
              rounded
              clearable
              filled
              small-chips
              cache-items
              deletable-chips
              label="Преподаватели группы"
              :disabled="teachers.loading"
              :loading="teachers.loading"
              large
              @update:search-input="search"
              @load-more-items="loadMoreItems"
            )
          sdo-back-button
          v-btn(
            @click="createGroup" :loading="loading" color="success" rounded depressed
          ) {{ $route.params.groupId ? 'Сохранить' : 'Создать'}}

</template>

<script>
import GroupService from '@/services/API/GroupService';

export default {
  name: 'GroupCreate',
  data() {
    return {
      fromData: {
        shortName: '',
        fullName: '',
        teachersSelected: [],
      },
      teachers: [],
      loading: false,
    };
  },
  computed: {
    query() {
      const [organization] = this.$user.data.organizations;
      return { 'search[organization]': organization.id };
    },
    serverDataAttrs() {
      return {
        query: {
          'search[organization]': this.$user.organization && this.$user.organization.id,
        },
      };
    },
  },
  created() {
    if (this.$route.params.groupId) this.getGroup();
  },
  methods: {
    async getGroup() {
      this.loading = true;
      const { data } = await GroupService.getGroup(this.$route.params.groupId, { params: { expand: 'teachers' } });
      this.fromData.fullName = data.data.full_name;
      this.fromData.shortName = data.data.short_name;
      this.fromData.status = data.data.status;
      this.loading = false;
    },
    createGroup() {
      this.loading = true;

      const data = {
        prior_record_id: this.$route.params.enrollmentId,
        groups_data: [{
          short_name: this.fromData.shortName,
          full_name: this.fromData.fullName,
          teachers: this.fromData.teachersSelected,
        }],
      };
      const updateData = {
        short_name: this.fromData.shortName,
        full_name: this.fromData.fullName,
        teachers: this.fromData.teachersSelected,
        status: this.fromData.status,
      };
      const method = (payload) => (this.$route.params.groupId
        ? GroupService.updateGroup(this.$route.params.groupId, payload)
        : GroupService.createGroups(payload));
      const payload = this.$route.params.groupId ? updateData : data;
      method(payload)
        .then(async (r) => {
          if (!this.$route.params.groupId) {
            const [id] = r.data.data;
            await this.$api.telegram.groupChannel(id);
            this.$toasted.success('Группа успешно создана', {
              duration: 2000,
            });
          }
          this.$router.go(-1);
        })
        .catch((err) => {
          const { response } = err;
          if (response?.data?.result_code === 'VAL01') {
            try {
              this.$refs.obs.setErrors(response.data.validation);
            } catch (e) {
              // console.log(e);
            }
          }
        })
        .finally(() => { this.loading = false; });
    },
  },
};
</script>
